export { default } from './NavLinks';
